import isFullArray from "./isFullArray";

export default course => {
  if (isFullArray(course.reviews)) {
    return course.reviews.length;
  }
  return 0;
};
